// extracted by mini-css-extract-plugin
export default {"header":"Admin_header__0VzqP","logo":"Admin_logo__2CH3j","title":"Admin_title__uLZKQ","menu":"Admin_menu__e+ezC","icon":"Admin_icon__PUWH+"};